import { render, staticRenderFns } from "./CustomPageCreate.vue?vue&type=template&id=823a88b0&"
import script from "./CustomPageCreate.vue?vue&type=script&lang=js&"
export * from "./CustomPageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports